import React, { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';

export const EditTimesheetDialog = ({ timesheet, token, apiCall, onDone }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(timesheet.date);
  const [startTime, setStartTime] = useState(timesheet.start_time);
  const [endTime, setEndTime] = useState(timesheet.end_time);
  const [breakMinutes, setBreakMinutes] = useState(timesheet.break_minutes || 0);
  const [busy, setBusy] = useState(false);

  const openDialog = () => {
    setDate(timesheet.date);
    setStartTime(timesheet.start_time);
    setEndTime(timesheet.end_time);
    setBreakMinutes(timesheet.break_minutes || 0);
    setOpen(true);
  };

  const submit = async () => {
    if (!date || !startTime || !endTime) {
      toast.error('Date, start and end time are required');
      return;
    }
    setBusy(true);
    try {
      await apiCall(`/timesheets/${timesheet.id}`, 'PUT', {
        shift_id: timesheet.shift_id,
        date,
        start_time: startTime,
        end_time: endTime,
        break_minutes: parseInt(breakMinutes, 10) || 0,
      }, token);
      toast.success('Timesheet updated — hours and pay recalculated');
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(e.detail || 'Failed to update timesheet');
    }
    setBusy(false);
  };

  return (
    <>
      <Button size="sm" variant="outline" className="border-blue-300 text-blue-700 hover:bg-blue-50"
        onClick={openDialog} data-testid={`edit-timesheet-btn-${timesheet.id}`}>
        ✏️ Edit
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Edit timesheet — {timesheet.staff_name || 'staff'}</DialogTitle>
            <DialogDescription>
              Correct the date or times if the staff member entered them wrongly. Total hours and pay are
              recalculated automatically. This change is recorded in the audit log.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div>
              <Label>Date</Label>
              <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="edit-ts-date" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Start time</Label>
                <Input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} data-testid="edit-ts-start" />
              </div>
              <div>
                <Label>End time</Label>
                <Input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} data-testid="edit-ts-end" />
              </div>
            </div>
            <div>
              <Label>Break (minutes)</Label>
              <Input type="number" min="0" value={breakMinutes} onChange={(e) => setBreakMinutes(e.target.value)} data-testid="edit-ts-break" />
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="bg-blue-600 hover:bg-blue-700" disabled={busy} onClick={submit} data-testid="edit-ts-submit">
                Save changes
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
